@if (nzTitle || nzExtra || listOfNzCardTabComponent || uiDescription) {
<div class="ant-card-head" [ngClass]="{ borderless: uiHeadBorderless }">
  <div class="ant-card-head-wrapper">
    @if (nzTitle) {
    <div class="ant-card-head-title">
      <ng-container *nzStringTemplateOutlet="nzTitle">{{ nzTitle }}</ng-container>
    </div>
    } @if (listOfNzCardTabComponent) {
    <ng-template [ngTemplateOutlet]="listOfNzCardTabComponent.template" />
    } @if (uiDescription) {
    <div class="ant-card-description">
      <ng-container *nzStringTemplateOutlet="uiDescription">{{ uiDescription }}</ng-container>
    </div>
    } @if (nzExtra) {
    <div class="ant-card-extra">
      <ng-container *nzStringTemplateOutlet="nzExtra">{{ nzExtra }}</ng-container>
    </div>
    }
  </div>
</div>
} @if (nzCover) {
<div class="ant-card-cover">
  <ng-template [ngTemplateOutlet]="nzCover" />
</div>
}

<div class="ant-card-body" [ngStyle]="nzBodyStyle">
  @if (nzLoading) {
  <ui-skeleton [uiActive]="true" [uiTitle]="false" [uiParagraph]="{ rows: 4 }"></ui-skeleton>
  } @else {
  <ng-content />
  }
</div>
@if (nzActions.length) {
<ul class="ant-card-actions">
  @for (action of nzActions; track $index) {
  <li [style.width.%]="100 / nzActions.length">
    <span><ng-template [ngTemplateOutlet]="action" /></span>
  </li>
  }
</ul>
}
